import { render, staticRenderFns } from "./detaille_facture_service.vue?vue&type=template&id=22767080&"
import script from "./detaille_facture_service.vue?vue&type=script&lang=js&"
export * from "./detaille_facture_service.vue?vue&type=script&lang=js&"
import style0 from "./detaille_facture_service.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports